import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "card reports-analytics"
}
const _hoisted_3 = { class: "table-total" }
const _hoisted_4 = { class: "label-text-total" }
const _hoisted_5 = { class: "report-site-visitors-and-time-session" }
const _hoisted_6 = { class: "bar-chart-horizontal" }
const _hoisted_7 = { class: "report-chart" }
const _hoisted_8 = { class: "report-lots-color" }
const _hoisted_9 = { class: "label-text-lots-background" }
const _hoisted_10 = { class: "report-table-lots-container" }
const _hoisted_11 = { class: "report-details-lot" }
const _hoisted_12 = { class: "label-text-lots bold-text" }
const _hoisted_13 = { class: "label-text-lots" }
const _hoisted_14 = {
  key: 1,
  class: "report-no-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "bar-chart-horizontal-title" }, [
          _createElementVNode("h2", { class: "title-main" }, "Website Analytics")
        ], -1)),
        ($setup.filteredDataFromAnalytics.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.transformedDataByEstate, (estateData, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "report-container",
                key: index
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(`www.${estateData.estate}.com.au`), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode($setup["SiteVisitorsFromAnalytics"], {
                    startDate: $setup.startDateSelected,
                    endDate: $setup.endDateSelected,
                    searchKey: $props.searchKey,
                    estateSelected: estateData.estateId
                  }, null, 8, ["startDate", "endDate", "searchKey", "estateSelected"]),
                  _createVNode($setup["TimeSessionByUsersFromAnalytics"], {
                    startDate: $setup.startDateSelected,
                    endDate: $setup.endDateSelected,
                    searchKey: $props.searchKey,
                    estateSelected: estateData.estateId
                  }, null, 8, ["startDate", "endDate", "searchKey", "estateSelected"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "title-main title-chart" }, "Top 5 Most Clicked Lots", -1)),
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(estateData.topFiveChartData.lots, (lot, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "lots-container-color",
                          key: index
                        }, [
                          _createElementVNode("div", {
                            class: "background-color",
                            style: _normalizeStyle({ backgroundColor: estateData.topFiveChartData.color[index] })
                          }, null, 4),
                          _createElementVNode("span", _hoisted_9, "Lot " + _toDisplayString(lot), 1)
                        ]))
                      }), 128))
                    ]),
                    _createVNode($setup["ChartForReports"], {
                      labels: estateData.topFiveChartData.lots,
                      setData: estateData.topFiveChartData.clicks,
                      backgroundColor: $setup.chartBackgroundColorForWebsiteAnalytics,
                      title: 'lots clicked',
                      chartType: $setup.ChartsTypes.BAR,
                      options: $setup.optionsBarChartForWebsiteAnalytics
                    }, null, 8, ["labels", "setData", "backgroundColor", "chartType", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(estateData.topFiveClickedLots, (lot, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "report-table-lots",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("span", _hoisted_12, "Lot " + _toDisplayString(lot.lot), 1),
                          _createElementVNode("span", _hoisted_13, "Stage " + _toDisplayString(lot.stage), 1)
                        ]),
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "report-details-lot-price" }, [
                          _createElementVNode("span", { class: "label-text-lots" }, "$xxx,xxx"),
                          _createElementVNode("span", { class: "label-text-lots" }, "xxx sqm")
                        ], -1))
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            }), 128))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("h2", { class: "subtitle-main" }, "No data to display", -1)
            ]))]))
      ]))
}